import React, { Component } from 'react'; 
import DesktopMemu, { } from './menucomponents/DesktopMemu';  

export default function ToggleLeftMenu () {
    
        return (
            <>

                <div>
                    <DesktopMemu />
                </div>
            </>

        )
    }

